import axios from "axios";

export function saveProfileChanges(newProfile, currentUser) {
  if (!currentUser || !currentUser.email) {
    throw new Error("No user email found");
  }

  return axios.post(`${process.env.REACT_APP_PUBLIC_BACKEND_URL}edit_profile`, {
    profile: newProfile,
    email: currentUser.email,
  });
}

export const defaultProfile = {
  cardType: "",
  businessPurpose: "",
  businessName: "",
  googleReviewLink: "",
  facebook: "",
  tiktok: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  college: "",
  linkedIn: "",
  x: "",
  instagram: "",
  github: "",
  portfolio: "",
  resume: "",
  additional: "",
  headline: "",
  degreeType: "",
  major: "",
  collegeStartYear: "",
  collegeStartMonth: "January",
  collegeEndYear: "",
  collegeEndMonth: "January",
  leadCapture: {
    tagline: "Join our mailing list",
    phoneEnabled: false,
    questions: [],
  },
  socialMediaConfig: {
    tagline: "Connect with us",
    brandColor: "#2563EB", // Default blue
    bannerImage: "", // Custom banner image URL
  },
};

// options a user can select for their degree type on their profile
export const degreeTypeOptions = [
  "Associate's",
  "Bachelor's",
  "Master's",
  "Doctorate",
  "PhD",
  "MBA",
  "PharMD",
  "JD",
  "MD",
  "Bootcamp",
  "Certification",
  "Other",
];

export const monthsOfYear = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
